import { Command } from 'commander';
import chalk from 'chalk';
import { testApiConnection } from '../api.js';
import { getApiKey, getApiEndpoint } from '../config.js';

export const testCommand = new Command('test')
  .description('Test API connection and API key')
  .option('-k, --api-key <key>', 'API key to test')
  .action(async (options) => {
    console.log(chalk.cyan('\n🧪 VibeTime Connection Test\n'));
    
    try {
      // Get API key
      const apiKey = await getApiKey(options);
      const endpoint = getApiEndpoint();
      
      console.log('API Endpoint: ' + chalk.gray(endpoint));
      console.log('API Key: ' + chalk.gray(`...${apiKey.slice(-8)}`));
      
      // Connection test
      const success = await testApiConnection(apiKey);
      
      if (success) {
        console.log(chalk.green('\n✅ All tests passed!'));
        console.log(chalk.gray('VibeTime is ready to use.'));
      } else {
        console.log(chalk.red('\n❌ Test failed'));
        console.log(chalk.gray('Please reconfigure your API key with `vibetime config set`.'));
        process.exit(1);
      }
    } catch (error: any) {
      console.error(chalk.red('\n❌ Error:'), error.message);
      process.exit(1);
    }
  });